import { Validator, install as VeeValidate } from 'vee-validate/dist/vee-validate.minimal.esm.js'
import {
  before,
  between,
  decimal,
  email,
  included,
  is,
  length,
  max,
  min,
  numeric,
  regex,
  required,
  size
} from 'vee-validate/dist/rules.esm.js'
import attributeTranslator from 'src/i18n/attributes'
import countryValidator from 'src/utils/validators/country'
import currencyValidator from 'src/utils/validators/currency'
import de from 'vee-validate/dist/locale/de'
import en from 'vee-validate/dist/locale/en'
import { getLocale } from 'src/utils/locale'
import ibanValidator from 'src/utils/validators/iban'
import invoicingItems from 'src/utils/validators/invoicingItems'
import localeValidator from 'src/utils/validators/locale'

export default ({ app, Vue }) => {
  Validator.localize('de', de)
  Validator.localize('en', en)

  // Built-in validation rules
  Validator.extend('before', before)
  Validator.extend('between', between)
  Validator.extend('decimal', decimal)
  Validator.extend('email', email)
  Validator.extend('included', included)
  Validator.extend('is', is)
  Validator.extend('length', length)
  Validator.extend('max', max)
  Validator.extend('min', min)
  Validator.extend('numeric', numeric)
  Validator.extend('required', required)
  Validator.extend('size', size)
  Validator.extend('regex', regex)

  // Custom validation rules
  Validator.extend('currency', currencyValidator)
  Validator.extend('locale', localeValidator)
  Validator.extend('country', countryValidator)
  Validator.extend('iban', ibanValidator)
  Validator.extend('invoicing_items', invoicingItems)

  let locale = getLocale()

  Vue.use(VeeValidate, {
    inject: false,
    locale,
    dictionary: {
      en: { attributes: attributeTranslator.getTranslations('en') },
      de: { attributes: attributeTranslator.getTranslations('de') }
    }
  })
}
